var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';

/**
 * Get Styled Component shimmer loader theme
 * @param options GetShimmerLoaderThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getShimmerLoaderTheme = function getShimmerLoaderTheme(options) {
  var look = options.look;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: linear-gradient(\n      to right,\n      ", " 4%,\n      ", " 25%,\n      ", " 36%\n    );\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.shimmerLoader[look].gradientLight;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.shimmerLoader[look].gradientDark;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.shimmerLoader[look].gradientLight;
  });
};
export { getShimmerLoaderTheme };